<div class="table-responsive list-wrapper-bordered">
    <table class="table table-striped table-hover table-borderless border-0 ">
        <thead>
        <tr>
            <th class="text-nowrap">Certification</th>
            <th class="text-nowrap">Document Type</th>
            <th class="text-nowrap">File</th>
            <th class="sticky-action"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let cert of userCEUs">
            <td style="color: #000;">{{cert.certificationTitle}}</td>
            <td style="color: #000;">{{maskingColumn('parameterLabel', 'parameterValue', docTypes.parameterMembers, cert.documentType)}}</td>
            <td style="color: #000;">{{cert.fileName}}</td>
            <td class="sticky-action">
                <button (click)="viewCert(cert)" style="color:#5B25B4" mat-icon-button aria-label="view ceu">
                    <mat-icon>arrow_forward</mat-icon>
                </button>
                <button (click)="downloadCert(cert)" style="color:#5B25B4" mat-icon-button aria-label="edit ceu">
                    <mat-icon>download</mat-icon>
                </button>
                <button (click)="editCertNew(cert)" style="color:#5B25B4" mat-icon-button aria-label="edit ceu">
                    <mat-icon>edit_square</mat-icon>
                </button>
                <button (click)="deleteCert(cert)" style="color:#5B25B4" mat-icon-button aria-label="delete ceu">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </tr>
        <tr *ngIf="!populate && userCEUs.length == 0">
            <td colspan="7" class="text-center">
                <span>No CEU available </span>
            </td>
        </tr>
        <tr *ngIf="populate">
            <td colspan="7" class="text-center">
                <span>Populate data... please wait</span>
            </td>
        </tr>
        </tbody>
    </table>
</div>
<div class="mt-4" *ngIf="userCEUs.length > 0">
    <app-pagination
            (goPage)="toPage($event)"
            (goPerPage)="perPageSet($event)"
            [pagesToShow]="showPages"
            [page]="pageNo"
            [perPage]="pageSize"
            [count]="totalRow"></app-pagination>
</div>
